import React, { useState } from 'react'
import { Checkbox } from 'antd'

const GutterBody = ({ id, isSelected, onPatternSelect }) => {
    const [isHovered, setIsHovered] = useState(false)

    const handleMouseEnter = () => setIsHovered(true)

    const handleMouseLeave = () => setIsHovered(false)

    let content
    if (onPatternSelect && (isHovered || isSelected)) {
        content = <Checkbox checked={isSelected} onChange={onPatternSelect} />
    } else if (id !== null) {
        content = id
    }

    return (
        <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {content}
        </div>
    )
}

export default GutterBody
